module.exports = __webpack_public_path__ + "img/GHS-pictogram-exclam.80f780d2.png";